

export function downloadBlob(blob, name = 'file.txt') {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = name;

    document.body.appendChild(link);

    link.dispatchEvent(
        new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
        })
    );

    document.body.removeChild(link);
}

// export function saveAsPng(scatterplot, scaleFactor = 1) {
//     // get position of user points
//     const originalCanvas = scatterplot.get('canvas');
//     const width = originalCanvas.width;
//     const height = originalCanvas.height;

//     const tempCanvas = document.createElement('canvas');
//     tempCanvas.width = width * scaleFactor;
//     tempCanvas.height = height * scaleFactor;
//     const tempCtx = tempCanvas.getContext('2d');

//     tempCtx.scale(scaleFactor, scaleFactor);
//     tempCtx.drawImage(originalCanvas, 0, 0);

//     tempCanvas.toBlob((blob) => {
//         downloadBlob(blob, `microverse_${width * scaleFactor}x${height * scaleFactor}.png`);
//     }, 'image/png');
// }

export function saveAsPng(scatterplot, scaleFactor = 1, basePointsLength = undefined) {
    // get position of user points
    const originalCanvas = scatterplot.get('canvas');
    const width = originalCanvas.width;
    const height = originalCanvas.height;

    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = width * scaleFactor;
    tempCanvas.height = height * scaleFactor;
    const tempCtx = tempCanvas.getContext('2d');

    tempCtx.scale(scaleFactor, scaleFactor);
    tempCtx.drawImage(originalCanvas, 0, 0);

    // // If basePointsLength is provided, highlight user points
    // if (basePointsLength !== undefined) {
    //     const allPoints = scatterplot.get('points');

    //     if (allPoints && allPoints.length > basePointsLength) {
    //         // const scale = Math.min(width, height) / 2;
    //         const scale = Math.min(width, height) / 2.1;
    //         const centerX = width / 2;
    //         const centerY = height / 2;

    //         // tempCtx.strokeStyle = 'rgba(255, 215, 0, 0.8)';
    //         // tempCtx.strokeStyle = 'rgba(0, 0, 0, 0.1)';
    //         // tempCtx.strokeStyle = 'rgba(0, 0, 0, 1.0)';
    //         // tempCtx.strokeStyle = 'rgba(0, 0, 0, 0.1)';
    //         tempCtx.strokeStyle = 'rgba(0, 0, 0, 0.8)';
    //         // tempCtx.lineWidth = 8;
    //         // tempCtx.lineWidth = 2;
    //         tempCtx.lineWidth = 4;

    //         // Draw circles around all user points
    //         for (let i = basePointsLength; i < allPoints.length; i++) {
    //             const point = allPoints[i];
    //             const x = centerX + point[0] * scale;
    //             const y = centerY - point[1] * scale;

    //             const radius = 32;
    //             // const radius = 40;

    //             tempCtx.beginPath();
    //             tempCtx.arc(x, y, radius, 0, 2 * Math.PI);
    //             tempCtx.stroke();
    //         }
    //     }
    // }

    tempCanvas.toBlob((blob) => {
        downloadBlob(blob, `microverse_${width * scaleFactor}x${height * scaleFactor}.png`);
    }, 'image/png');
}

export function saveAsSvg(scatterplot) {
    // Get the canvas and dimensions
    const canvas = scatterplot.get('canvas');
    const width = canvas.width;
    const height = canvas.height;
    console.log(width, height);

    const pointsData = scatterplot.get('points');

    const selectedPoints = scatterplot.get('selectedPoints') || [];
    const pointSizes = scatterplot.get('pointSize');
    const minPointSize = Array.isArray(pointSizes) ? pointSizes[0] : pointSizes;
    const maxPointSize = Array.isArray(pointSizes) ? pointSizes[1] : pointSizes;

    // let svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
    // <rect width="${width}" height="${height}" fill="${scatterplot.get('backgroundColor') || '#ffffff'}"/>`;
    let svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="${width / 2}" height="${height / 2}" viewBox="0 0 ${width} ${height}">
    <rect/>`;


    const colorPalette = scatterplot.get("pointColor");
    // console.log(colorPalette);

    const globalPointOpacity = scatterplot.get('opacity');
    const pointOpacityInactive = scatterplot.get('opacityInactiveScale');


    if (pointsData && pointsData.length > 0) {
        pointsData.forEach((point, index) => {
            const scale = Math.min(width, height) / 2;
            const centerX = width / 2;
            const centerY = height / 2;

            const x = centerX + point[0] * scale;
            const y = centerY - point[1] * scale;


            const sizeIndex = point[2]


            const colorIndex = point[3]

            let color;
            // console.log(colorIndex);
            if (Number(colorIndex) === colorIndex && colorIndex % 1 !== 0) {
                color = rgbToHex(colorPalette[parseInt(colorIndex * 100)])
            } else {
                color = rgbToHex(colorPalette[colorIndex])
            }

            // let color = rgbToHex(colorPalette[colorIndex])


            const isSelected = selectedPoints.includes(index);
            const stroke = isSelected ? '#ffffff' : 'none';
            // const stroke = isSelected ? color : 'none';
            const strokeWidth = isSelected ? 2 : 0;

            let size = isSelected ? pointSizes[sizeIndex] + 10 : pointSizes[sizeIndex];

            let pointOpacity;
            if (selectedPoints.length > 0) {
                pointOpacity = isSelected ? globalPointOpacity : pointOpacityInactive;
            } else {
                pointOpacity = globalPointOpacity;
            }


            svgContent += `<circle cx="${x}" cy="${y}" r="${size}" fill="${color}" opacity="${pointOpacity}" stroke="${stroke}" stroke-width="${strokeWidth}" />`;
        });
    }

    svgContent += `</svg>`;

    const blob = new Blob([svgContent], { type: 'image/svg+xml;charset=utf-8' });
    downloadBlob(blob, 'microverse_scatterplot.svg');
}

function rgbToHex(rgb) {

    if (Array.isArray(rgb)) {
        // convert [r,g,b] array to hex
        return '#' + rgb.slice(0, 3).map(x => {
            const hex = Math.round(x * 255).toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        }).join('');
    }
    return rgb;
}



// export function saveAsPng(scatterplot) {
//     const imageObject = new Image();
//     imageObject.onload = () => {
//         scatterplot.get('canvas').toBlob((blob) => {
//             downloadBlob(blob, 'microverse.png');
//         });
//     };
//     imageObject.src = scatterplot.get('canvas').toDataURL();
// }